import { useEffect } from 'react';

import { loadUserData } from "#redux/actions/authActions";
import { useAppDispatch } from "#redux/store";

function AuthFetcher() {
  const dispatch = useAppDispatch();

  useEffect(
    () => {
      dispatch(loadUserData());
    },
    [dispatch],
  );

  return null;
}

export default AuthFetcher;
